import { render, staticRenderFns } from "./ChooseAvatar.vue?vue&type=template&id=b9c0acfa&scoped=true"
import script from "./ChooseAvatar.vue?vue&type=script&lang=js"
export * from "./ChooseAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c0acfa",
  null
  
)

export default component.exports